import DOMPurify from 'dompurify';

// Configure DOMPurify to allow links
const purifyConfig = {
  ALLOWED_TAGS: [
    'a',
    'p',
    'br',
    'strong',
    'em',
    'b',
    'i',
    'u',
    'span',
    'div',
    'ul',
    'li',
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'id'],
  ALLOW_DATA_ATTR: false,
};

export const vSafeHtml = {
  beforeMount(el, binding) {
    if (binding.value) {
      el.innerHTML = DOMPurify.sanitize(binding.value, purifyConfig); // Render Html safely with links allowed
    }
  },
  updated(el, binding) {
    if (binding.value) {
      el.innerHTML = DOMPurify.sanitize(binding.value, purifyConfig);
    }
  },
};
